import { render, staticRenderFns } from "./WsChipList.vue?vue&type=template&id=13213965&"
import script from "./WsChipList.vue?vue&type=script&lang=js&"
export * from "./WsChipList.vue?vue&type=script&lang=js&"
import style0 from "./WsChipList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
